import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "alarm",
  "use": "alarm-usage",
  "viewBox": "0 0 19.66 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.66 20\" id=\"alarm\"><title>alarm</title><path d=\"M9.8 5.8a5 5 0 0 0-5 5V17h10.08v-6.19a5 5 0 0 0-5-5zm-5.81 3a.82.82 0 0 0-.64-1L.99 7.37A.832.832 0 1 0 .66 9l2.33.44a.82.82 0 0 0 1-.64zm-.55-5.47l1.55 1.88a.82.82 0 0 0 1.27-1l-1.55-1.9a.82.82 0 0 0-1.44.63.81.81 0 0 0 .17.39zM9.93 4a.82.82 0 0 0 .84-.8V.84A.82.82 0 0 0 9.13.8v2.41a.84.84 0 0 0 0 .14.82.82 0 0 0 .8.65zm3.78 1.52a.82.82 0 0 0 1.15-.07l1.59-1.81a.82.82 0 1 0-1.23-1.08l-1.58 1.81a.82.82 0 0 0 .07 1.15zm5.95 2.95a.82.82 0 0 0-.93-.68l-2.38.36a.82.82 0 1 0 .25 1.61l2.39-.36a.82.82 0 0 0 .67-.93zm-3 10.37A1.16 1.16 0 0 1 15.5 20H3.91a1.16 1.16 0 0 1-1.16-1.16 1.16 1.16 0 0 1 1.16-1.16H15.5a1.16 1.16 0 0 1 1.16 1.16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/alarm.svg
// module id = YdUd
// module chunks = 6